import { useState } from 'react';
import { faqItems } from '../../../mocks/services';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-gray-50/60">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
            Preguntas Frecuentes
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Todo lo que Necesitas Saber
          </h2>
          <p className="text-gray-500">
            Resolvemos las dudas más comunes sobre el envío de dinero a Venezuela.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIdx === idx ? 'border-green-300 bg-white' : 'border-gray-200 bg-white hover:border-green-200'
              }`}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full text-left flex items-start gap-4 px-6 py-5 cursor-pointer"
              >
                <span
                  className={`mt-0.5 w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                    openIdx === idx ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  <i className={`ri-${openIdx === idx ? 'subtract' : 'add'}-line text-xs font-bold`} />
                </span>
                <span className={`font-semibold text-sm leading-relaxed ${openIdx === idx ? 'text-green-700' : 'text-gray-800'}`}>
                  {item.q}
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5 pl-[3.75rem]">
                  <p className="text-gray-500 text-sm leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-400 text-sm">
            ¿Tienes otra pregunta?{' '}
            <a href="mailto:info@remesasve.com" className="text-green-600 hover:text-green-700 font-medium">
              Escríbenos
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
